// Base service name
export const SERVICE_NAME = "NOTIFICATION_SERVICE";
